import { menu } from 'icons/menu.js';
import { micActive } from 'icons/micActive.js';
import { sendButton } from 'icons/send.js';
import { FaqToggleBtns } from './components/faqAutocomplete/faqAutocomplete.template';

import './components/voiceInput/voiceInput.scss';
import './replyInput.scss';

export const ReplyInputTemplate = (model) => {
	const { bgColor, isVoiceEnabled, isMenuConfigured, isFaqAutocompleteEnabled } = model || {};

	/* html */
	const menuBtnHtml = isMenuConfigured
		? `
	<button 
		id="engtMenuBtn"
		class="engt-btn-icons engt-tab-selectable engt-reply-btns" 
		aria-label="Menu">
		${menu()}
	</button>`
		: '';

	/* html */
	const voiceInputHtml = isVoiceEnabled
		? `
	<div id="engtVoiceWrapper">
		    <button id="engtVoiceInputBtn" class="engt-btn-icons  engt-tab-selectable">
		      ${micActive()}
		    </button>
    </div>`
		: '';

	/* html */
	const html = `
		<div id="engtReplyInput" style="position: relative; background: ${bgColor}; width: 100%;">
			<div id="engtInputError"></div>
			<div class="engt-reply-area">	
				<div
					role="textbox"
					contenteditable
					class="engt-user-msg-input"
					id="engtUserMessage"
					data-placeholder="${model.placeholder}"
				></div>
				<file-attachment></file-attachment>
				${isFaqAutocompleteEnabled ? FaqToggleBtns : ''}
				<button
					id="engtSendBtn"
					class="engt-btn-icons engt-tab-selectable engt-hidden engt-reply-btns"
					aria-label="Send Message"
				>
					${sendButton()}
				</button>
			</div>
			<div id="engt-non-input-mode" class="engt-voice-input" style="display:none">
			</div>
		</div>
		${voiceInputHtml}
		${menuBtnHtml}
    `;

	return html;
};
